
import { BlogSection } from '@/types/blog';

export const fuehrungsstilSection: BlogSection = {
  id: 'fuehrungsstil',
  title: 'Coaching als Führungsstil der Zukunft',
  content: `
    <p>
      Coaching entwickelt sich zu einem <strong>Führungsstil der Zukunft</strong>, der sowohl 
      in Unternehmen als auch im persönlichen Leben wirksam ist. 
      Dies gilt für verschiedene Bereiche:
    </p>
    
    <ul class="my-4 space-y-2">
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Unternehmen und ihre Führungskräfte</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Familien und die Kommunikation mit Heranwachsenden</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Persönliche Finanzentscheidungen und langfristige Planung</span>
      </li>
    </ul>
    
    <p>
      Besonders in der Kommunikation mit Heranwachsenden können Coaching-Methoden zu einer 
      wertschätzenden und effektiven Gesprächsführung beitragen.
    </p>
  `
};
